/* eslint-disable class-methods-use-this */
import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';
import DiagramEngine from '../WVDiagramModel';
import { DefaultLabelModel } from './DefaultLabelModel';
import { DefaultLabelWidget } from './DefaultLabelWidget';

/**
 * @author Dylan Vorster
 */
// @ts-ignore
class DefaultLabelFactory extends AbstractReactFactory<DefaultLabelModel, DiagramEngine> {
  constructor() {
    super('default');
  }

  generateReactWidget(event: any): JSX.Element {
    return <DefaultLabelWidget model={event.model} />;
  }

  generateModel(event: any): DefaultLabelModel {
    return new DefaultLabelModel();
  }
}

export default DefaultLabelFactory;
